import { render, staticRenderFns } from "./CovidTotalsTable.vue?vue&type=template&id=290cdbfc&"
import script from "./CovidTotalsTable.vue?vue&type=script&lang=js&"
export * from "./CovidTotalsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports